// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { getLoginPayload } from '@tcp/core/src/constants/analytics';
import ClickTracker from '@tcp/web/src/components/common/atoms/ClickTracker';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Button from '@tcp/core/src/components/common/atoms/Button';
import Router from 'next/router'; //eslint-disable-line
import withStyle from '../../../../common/hoc/withStyles';
import style, { GuestSFLSection } from '../styles/EmptyBagPage.style';
import { getLocator } from '../../../../../utils';
import utility from '../../Checkout/util/utility';
import { CHECKOUT_ROUTES } from '../../Checkout/Checkout.constants';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../utils/labels/labelUtilty';
import BAGPAGE_LABELS from '../../BagPage/container/Bagpage.labels';
import {
  GLOBAL_GENERIC_LABELS,
  GlobalGenericLabels,
  lblShopNow,
} from '../../../../../utils/labels/globalGeneric.labels';

const renderEmptySFL = (
  isUserLoggedIn,
  onLinkClick,
  labels,
  rememberedUser,
  emptySflMsg1,
  loginLbl
) => {
  if (!isUserLoggedIn && !rememberedUser) {
    return (
      <GuestSFLSection>
        <BodyCopy
          color="gray.900"
          fontSize="fs14"
          fontWeight="demiBold"
          fontFamily="secondary"
          textAlign="center"
          className="elem-mt-XL_1"
        >
          {labels.sflLoginSuggestionLabel}
        </BodyCopy>

        <div className="guest-sfl-login-section">
          <Button
            className="CTA-button"
            onClick={(e) => {
              const login = 'login';
              onLinkClick({ e, componentId: login });
            }}
          >
            <BodyCopy
              component="span"
              color="white"
              fontWeight="extrabold"
              fontFamily="secondary"
              fontSize="fs14"
            >
              {loginLbl}
            </BodyCopy>
          </Button>
        </div>
      </GuestSFLSection>
    );
  }
  return (
    <div className="empty-sfl-msg">
      <BodyCopy
        color="black"
        fontSize="fs16"
        fontWeight="semibold"
        fontFamily="secondary"
        textAlign="center"
        dataLocator={getLocator('empty_sfl_Msg_1')}
      >
        {emptySflMsg1}
      </BodyCopy>
      <BodyCopy
        color="gray.800"
        fontSize="fs12"
        fontFamily="secondary"
        textAlign="center"
        dataLocator={getLocator('empty_sfl_Msg_2')}
        className="empty-sfl-message"
      >
        {labels.sflSuggestionLabel}
      </BodyCopy>
    </div>
  );
};
const getEmptyBagHeading = (
  isUserLoggedIn,
  isNewSFL,
  rememberedUser,
  loggedInMsg,
  guestUserMsg
) => {
  if (isNewSFL) return isUserLoggedIn || rememberedUser ? loggedInMsg : guestUserMsg;
  return !isUserLoggedIn ? guestUserMsg : loggedInMsg;
};

const emptyBagBtnHandler = (e, isUserLoggedIn, isNewSFL, rememberedUser, onLinkClick) => {
  setTimeout(() => {
    if (isNewSFL) {
      if (isUserLoggedIn || rememberedUser) {
        const page = CHECKOUT_ROUTES.home;
        utility.routeToPage(page);
      } else {
        const login = 'login';
        onLinkClick({ e, componentId: login });
      }
    } else if (!isNewSFL) {
      if (!isUserLoggedIn) {
        const login = 'login';
        onLinkClick({ e, componentId: login });
      } else {
        const page = CHECKOUT_ROUTES.home;
        utility.routeToPage(page);
      }
    }
  }, 0);
};

const getEmptyBagBtnLabel = (isNewSFL, isUserLoggedIn, rememberedUser, loginLbl) => {
  const genericLabels = getLabelFromCopyOrFromTranslation(
    `${GLOBAL_GENERIC_LABELS}`,
    GlobalGenericLabels
  );
  if (isNewSFL) {
    if (isUserLoggedIn || rememberedUser)
      return renderLabel(genericLabels[lblShopNow], 'shopNowLbl');
    return renderLabel(loginLbl, 'loginLbl');
  }
  if (!isNewSFL) {
    if (!isUserLoggedIn) return renderLabel(loginLbl, 'loginLbl');
    return renderLabel(genericLabels[lblShopNow], 'shopNowLbl');
  }
  return '';
};

const EmptyBagPage = ({
  className,
  isUserLoggedIn,
  isBagPageSflSection,
  onLinkClick,
  isNewSFL,
  rememberedUser,
}) => {
  const {
    lbl_emptyBag_loginIn: loginLbl,
    lbl_emptyBag_loggedInMsg: loggedInMsg,
    lbl_emptyBag_notLoggedInMsg: guestUserMsg,
    lbl_sfl_emptySflMsg_1: emptySflMsg1,
    lbl_login_suggestion_for_sfl: sflLoginSuggestionLabel,
    lbl_saving_for_later_suggestion: sflSuggestionLabel,
  } = getLabelFromCopyOrFromTranslation('checkout.bagPage', BAGPAGE_LABELS);

  return (
    <div className={className}>
      {isBagPageSflSection ? (
        renderEmptySFL(
          isUserLoggedIn,
          onLinkClick,
          { sflLoginSuggestionLabel, sflSuggestionLabel },
          rememberedUser,
          emptySflMsg1,
          loginLbl
        )
      ) : (
        <>
          <BodyCopy
            className="large-size-message"
            color="gray.900"
            fontWeight="extrabold"
            fontFamily="secondary"
            dataLocator={getLocator('empty_bag_Msg')}
          >
            {getEmptyBagHeading(
              isUserLoggedIn,
              isNewSFL,
              rememberedUser,
              loggedInMsg,
              guestUserMsg
            )}
          </BodyCopy>

          <div className="element-spacing">
            <ClickTracker clickData={getLoginPayload('cart')}>
              <Button
                data-locator={getLocator(
                  isUserLoggedIn ? 'empty_bag_loginUserCTA' : 'empty_bag_guestUserCTA'
                )}
                className="CTA-button"
                onClick={(e) => {
                  emptyBagBtnHandler(e, isUserLoggedIn, isNewSFL, rememberedUser, onLinkClick);
                }}
              >
                <BodyCopy
                  component="span"
                  color="white"
                  fontWeight="extrabold"
                  fontFamily="secondary"
                  fontSize="fs14"
                >
                  {getEmptyBagBtnLabel(isNewSFL, isUserLoggedIn, rememberedUser, loginLbl)}
                </BodyCopy>
              </Button>
            </ClickTracker>
          </div>
        </>
      )}
    </div>
  );
};

EmptyBagPage.propTypes = {
  className: PropTypes.string.isRequired,
  isUserLoggedIn: PropTypes.bool.isRequired,
  isBagPageSflSection: PropTypes.bool,
  onLinkClick: PropTypes.func.isRequired,
};

EmptyBagPage.defaultProps = {
  isBagPageSflSection: false,
};

export default withStyle(EmptyBagPage, style);
export { EmptyBagPage as EmptyBagPageVanilla };
